import React, { FC } from "react";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useLocale } from "../../contexts/localeContext";
import { CheckboxNodeField, TreeHierarchy } from "./checkboxNodeField";
import "./checkboxTree.css";

interface CheckboxTreeProps {
    tree: TreeHierarchy | undefined;
    compact?: boolean;
    onCheck?: (node: TreeHierarchy, fieldValues) => void
    onToggleExpand?: (node:TreeHierarchy) => void
}

const CheckboxTree: FC<CheckboxTreeProps> = ({ tree, compact = true, onCheck, onToggleExpand }) => {
    const { translate } = useLocale();
    return <>
        <div className={`flex flex-col text-sm ${compact
            ? ''
            : 'border-gray-300 border-solid border-t-2'
            }  h-full`}>
            {tree ? <CheckboxNodeField removeCheckBox={true} key={tree.id} node={tree} compact={compact} onCheck={onCheck} onToggleExpand={onToggleExpand} collapse={true}></CheckboxNodeField>

                : <div>{translate.byKey(TranslationKeys.noAvailableOptions)}</div>
            }
        </div>
    </>
}

export default CheckboxTree;